import { Navigate } from 'react-router-dom';
import { useVendorStore } from '@/store/vendor-store';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useVendorStore((s) => s.isAuthenticated);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
